import React from 'react';

const TrustBar: React.FC = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-gray-50 to-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-8">
          <p className="text-sm font-medium text-gray-600 tracking-wide uppercase mb-4">
            As referenced in emerging tech reports by
          </p>
          <div className="flex flex-wrap items-center justify-center gap-12">
            <div className="flex items-center gap-3 text-gray-800">
              <i className="ri-apple-fill text-3xl"></i>
              <span className="text-lg font-semibold">Apple</span>
            </div>
            <div className="flex items-center gap-3 text-gray-800">
              <i className="ri-google-play-fill text-3xl"></i>
              <span className="text-lg font-semibold">Google Play</span>
            </div>
            <div className="flex items-center gap-3 text-gray-800">
              <i className="ri-amazon-fill text-3xl"></i>
              <span className="text-lg font-semibold">AWS</span>
            </div>
            <div className="flex items-center gap-3 text-gray-800">
              <i className="ri-meta-fill text-3xl"></i>
              <span className="text-lg font-semibold">Meta Research</span>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-6 max-w-3xl mx-auto">
            CrowdRounds benchmarks against category standards from leading app ecosystems. These references indicate the platforms and research we analyze, not partnerships or endorsements.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
